import api from '@/api'

export default {
  fetch (isin, pointingPortfolio = false) {
    return api.get(`/investments/${isin}${pointingPortfolio ? '?pointing_portfolios=true' : ''}`)
  },

  fetchMarketFunds(isin) {
    return api.get(`/investments/quotes?isins=${isin.join()}&last_only=true`)
  }
}
